import { Component, OnInit } from '@angular/core';
import { ICountry } from '../../../../core/models/country.interface';
import { IPaginatorProperties } from '../../../../core/models/paginator.interface';
import { ConstantService } from '../../../../core/services/constant.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ICarrierItem, IService, ISubService, IVendor } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../services/shipment-price.service';

@Component({
    selector: 'eci-files-uploaded',
    templateUrl: './files-uploaded.component.html',
    styleUrls: ['./files-uploaded.component.scss'],
})

export class FilesUploadedComponent implements OnInit {
    public selectedTab: number = 0;

    public vendors: IPaginatorProperties<IVendor> = {items: [], meta: undefined};
    public services: IPaginatorProperties<IService> = {items: [], meta: undefined};
    public carriers: IPaginatorProperties<ICarrierItem> = {items: [], meta: undefined};
    public subServices: IPaginatorProperties<ISubService> = {items: [], meta: undefined};
    public files: IPaginatorProperties<{ id: number; fileName: string }> = {items: [], meta: undefined};
    public countriesList: ICountry[];

    constructor(private notify: NotificationService,
                private shipmentPriceSvc: ShipmentPriceService,
                private constSvc: ConstantService) {
    }

    ngOnInit(): void {
        this.getListOfCountries();
        this.getParams<IVendor>('vendor', 'vendors', 'name', 'ASC');
        this.getParams<IService>('service', 'services', 'name', 'ASC');
        this.getParams<ISubService>('sub-service', 'subServices', 'name', 'ASC');
        this.getParams<ICarrierItem>('carriers', 'carriers', 'name', 'ASC');
        this.getParams<{ id: number; fileName: string }>('shipment-price-document/price-files-name', 'files', 'name', 'ASC');

    }

    private getListOfCountries(
        page: number = 1,
        q: string = '',
        limit: number = 1000,
        withTaxRate: boolean = false,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, false, q, withTaxRate).subscribe(data => {
            if (data) {
                this.countriesList = data.items;
            }
        });
    }

    private getParams<T>(path: string, objectName: string,
                         orderField: string = 'createdAt',
                         orderDirection: string = 'DESC',
                         page: number = 1,
                         limit: number = 1000, q: string = ''): void {
        this.shipmentPriceSvc.get<IPaginatorProperties<T>>(path, page, limit, q, {select: 'dropdown'}, orderField, orderDirection)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this[objectName].items = [...this[objectName].items, ...data.items];
                this[objectName].meta = data?.meta;
            });
    }
}
